// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Reset base ── */
html, body, #root {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

body {
  background: var(--sn-superficie);
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* ── Wrapper principal ── */
.ln-wrapper {
  height: 100vh;
  height: 100dvh; /* altura real visible en móviles */
  background: var(--sn-superficie);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px 10px;
  box-sizing: border-box;
  overflow: hidden; /* todo cabe en una pantalla, sin scroll */
}

/* ── Logo ── */
.ln-logo-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 360px;
  margin-bottom: 8px;
  padding-top: env(safe-area-inset-top, 0);
}

/* Logo horizontal de la marca, en el espacio de la ilustración.
   El JPG trae fondo blanco, que coincide con el fondo claro del login. */
/* El video del logo es cuadrado, pero el logo dentro es horizontal: un 34%
   del cuadro son franjas blancas vacías arriba y abajo. Se recorta ese vacío
   dándole al contenedor la proporción del contenido real y usando "cover".
   El recorte es solo vertical: a lo ancho se ve el video completo. */
.ln-stage.ln-stage--video {
  /* El video es cuadrado pero el logo ocupa 1402x1182: sobra un 18% vertical.
     Se recorta ese vacío (solo vertical; a lo ancho se ve completo). */
  aspect-ratio: 1.16 / 1; /* más específico que el .ln-stage cuadrado de abajo */
  /* Dentro de un flex en columna, el alto natural del video (cuadrado) haría
     crecer la caja e ignoraría la proporción. Esto se lo impide. */
  min-height: 0;
  flex: 0 0 auto;
}

.ln-logo-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 66%; /* compensa que el logo está bajo el centro */
  display: block;
}

/* Ícono de la marca en la cabecera del login.
   Mismo logo y estilo que la barra superior de la app (.an-logo-img). */
.ln-logo-img {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: contain;
  flex-shrink: 0;
}

/* Versión pequeña, para la cabecera de "Iniciar sesión". */
.ln-logo-img--sm {
  width: 30px;
  height: 30px;
}

.ln-logo-box {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, var(--sn-marca-fuerte) 0%, var(--sn-marca) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: var(--sn-sombra);
}

.ln-logo-box span {
  color: var(--sn-texto-invertido);
  font-size: 20px;
  font-weight: 900;
  letter-spacing: -1px;
}

.ln-brand {
  font-size: 16px;
  font-weight: 800;
  color: var(--sn-marca-fuerte);
  line-height: 1.1;
  letter-spacing: .5px;
}

.ln-subbrand {
  font-size: 10px;
  color: var(--sn-texto-3);
  font-weight: 500;
  letter-spacing: 1px;
}

/* ── Ilustración ── */
.ln-illus-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 360px;
  margin-bottom: 4px;
}

.ln-svg {
  width: auto;
  max-width: 230px;
  height: auto;
  max-height: 30vh; /* la ilustración se adapta a la altura disponible */
  min-height: 0;
}

/* ── Escenario con la ilustración ── */
.ln-stage {
  position: relative;
  width: 230px;
  max-width: 100%;
  aspect-ratio: 1 / 1;
  margin: 0 auto;
  border-radius: 20px;
}

.ln-stage--solo {
  background: var(--sn-superficie-2);
}

.ln-lottie {
  width: 100%;
  height: 100%;
}

.ln-glow {
  position: absolute;
  left: 51%;
  top: 20%;
  width: 16%;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background: radial-gradient(circle, var(--sn-marca-suave) 0%, transparent 70%);
  animation: lnGlowPulse 3s ease-in-out infinite;
  animation-delay: 1.1s;
  pointer-events: none;
}

@keyframes lnGlowPulse {
  0%, 100% { opacity: 0; transform: scale(0.6); }
  20%       { opacity: 1; transform: scale(1.1); }
  55%       { opacity: 0.7; transform: scale(1); }
  75%       { opacity: 0; transform: scale(0.8); }
}

.ln-fx {
  position: absolute;
}

.ln-fx svg {
  width: 100%;
  display: block;
}

.ln-fx-chat {
  left: 4%;
  top: 36%;
  width: 15%;
  transform-origin: 30% 70%;
  animation: lnBubblePulse 2.4s ease-in-out infinite;
}

@keyframes lnBubblePulse {
  0%, 100% { transform: scale(1) rotate(0deg); }
  50%       { transform: scale(1.12) rotate(-4deg); }
}

.ln-fx-play {
  left: 46%;
  top: 56%;
  width: 12%;
  animation: lnPlayPulse 1.6s ease-in-out infinite;
}

@keyframes lnPlayPulse {
  0%, 100% { transform: scale(1); filter: drop-shadow(0 0 0px transparent); }
  50%       { transform: scale(1.15); filter: drop-shadow(0 0 10px var(--sn-marca)); }
}

.ln-fx-reply {
  left: 46%;
  top: 12%;
  width: 9%;
  opacity: 0;
  animation: lnReplyPop 3s ease-in-out infinite;
  animation-delay: 1.1s;
}

@keyframes lnReplyPop {
  0%   { opacity: 0; transform: scale(0.4) translateY(10px); }
  12%  { opacity: 1; transform: scale(1.15) translateY(-4px); }
  22%  { opacity: 1; transform: scale(1) translateY(0); }
  55%  { opacity: 1; transform: scale(1) translateY(0); }
  75%  { opacity: 0; transform: scale(0.7) translateY(6px); }
  100% { opacity: 0; transform: scale(0.4) translateY(10px); }
}

.ln-fx-arrow1 {
  left: 28%;
  top: 25%;
  width: 18%;
  animation: lnArrowFlow1 2.4s ease-in-out infinite;
}

@keyframes lnArrowFlow1 {
  0%   { opacity: 0.35; transform: translate(0, 0); }
  45%  { opacity: 1;    transform: translate(4px, -4px); }
  100% { opacity: 0.35; transform: translate(0, 0); }
}

.ln-fx-arrow2 {
  left: 62%;
  top: 50%;
  width: 15%;
  animation: lnArrowFlow2 2.4s ease-in-out infinite;
  animation-delay: 1.2s;
}

@keyframes lnArrowFlow2 {
  0%   { opacity: 0.35; transform: translate(0, 0); }
  45%  { opacity: 1;    transform: translate(-4px, 4px); }
  100% { opacity: 0.35; transform: translate(0, 0); }
}

.ln-typing {
  position: absolute;
  left: 33%;
  top: 87%;
  display: flex;
  gap: 5px;
}

.ln-typing span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--sn-marca);
  opacity: 0.85;
  animation: lnDotBounce 1.1s ease-in-out infinite;
}

.ln-typing span:nth-child(2) { animation-delay: 0.15s; }
.ln-typing span:nth-child(3) { animation-delay: 0.3s; }

@keyframes lnDotBounce {
  0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
  30%            { transform: translateY(-5px); opacity: 1; }
}

/* Animación: flote suave de todo el grupo */
.ln-svg-float {
  animation: lnFloat 3.6s ease-in-out infinite;
}

/* Animación: brazo saludando */
.ln-svg-wave {
  transform-origin: 1020px 410px;
  animation: lnWave 2.2s ease-in-out infinite;
}

/* Animación: cabeza asintiendo */
.ln-svg-nod {
  transform-origin: 910px 370px;
  animation: lnNod 4.5s ease-in-out infinite;
}

/* Animación: planta meciéndose */
.ln-svg-sway {
  transform-origin: center bottom;
  animation: lnSway 3.2s ease-in-out infinite;
}

/* Animación: pulso del punto */
.ln-svg-pulse {
  animation: lnPulse 1.8s ease-in-out infinite;
}

@keyframes lnFloat {
  0%, 100% { transform: translateY(0) translateX(-601px) translateY(-140px); }
  50%       { transform: translateY(-8px) translateX(-601px) translateY(-140px); }
}

@keyframes lnWave {
  0%, 100% { transform: rotate(0deg); }
  30%       { transform: rotate(10deg); }
  70%       { transform: rotate(-5deg); }
}

@keyframes lnNod {
  0%, 100% { transform: rotate(0deg); }
  35%       { transform: rotate(4deg); }
  70%       { transform: rotate(-3deg); }
}

@keyframes lnSway {
  0%, 100% { transform: rotate(0deg); }
  50%       { transform: rotate(4deg); }
}

@keyframes lnPulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.4; }
}

/* Frase */
.ln-tagline {
  font-size: 12px;
  color: var(--sn-marca);
  font-weight: 600;
  font-style: italic;
  text-align: center;
  margin: 0;
  letter-spacing: 0.2px;
}

/* ── Tarjeta de acceso ── */
.ln-card {
  width: 100%;
  max-width: 360px;
  padding: 10px 0 0;
}

/* ── Alerta de error ── */
.ln-alert {
  background: var(--sn-peligro-suave);
  border: 1px solid var(--sn-peligro);
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  color: var(--sn-peligro-texto);
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Aviso informativo (no es un error): sesión cerrada por inactividad */
.ln-alert--info {
  background: var(--sn-info-suave);
  border-color: var(--sn-borde-fuerte);
  color: var(--sn-info-texto);
}

.ln-alert-icon {
  font-size: 15px;
  flex-shrink: 0;
}

/* ── Títulos ── */
.ln-heading {
  font-size: 20px;
  font-weight: 700;
  color: var(--sn-texto);
  margin: 0 0 4px;
}

.ln-subheading {
  font-size: 13px;
  color: var(--sn-texto-2);
  margin: 0 0 18px;
}

/* ── Grid de botones de acceso (modo íconos) ── */
.ln-btn-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 18px;
}

.ln-access-btn {
  background: var(--sn-superficie-2);
  border: 1.5px solid var(--sn-borde-fuerte);
  border-radius: 16px;
  padding: 18px 10px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: border-color 0.18s, background 0.18s, transform 0.12s;
  font-family: inherit;
}

.ln-access-btn:hover {
  background: var(--sn-superficie-3);
  border-color: var(--sn-marca);
}

.ln-access-btn:active {
  transform: scale(0.97);
}

.ln-access-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ln-access-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--sn-marca-fuerte) 0%, var(--sn-marca) 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--sn-sombra);
}

.ln-access-icon svg {
  width: 26px;
  height: 26px;
  color: var(--sn-texto-invertido);
  fill: var(--sn-texto-invertido);
}

.ln-access-icon {
  font-size: 26px;
  color: var(--sn-texto-invertido);
}

.ln-access-btn span {
  font-size: 12px;
  font-weight: 600;
  color: var(--sn-texto-2);
  text-align: center;
  line-height: 1.4;
}

/* ── Formulario ── */
.ln-field {
  margin-bottom: 14px;
}

.ln-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--sn-texto-2);
  margin-bottom: 6px;
  display: block;
}

.ln-input {
  background: var(--sn-superficie-3) !important;
  border: 1.5px solid var(--sn-borde-fuerte) !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  color: var(--sn-texto) !important;
  padding: 10px 14px !important;
  transition: border-color 0.18s, box-shadow 0.18s !important;
}

.ln-input:focus {
  border-color: var(--sn-marca) !important;
  box-shadow: 0 0 0 3px var(--sn-marca-suave) !important;
  background: var(--sn-superficie) !important;
}

.ln-input::placeholder {
  color: var(--sn-texto-3) !important;
}

.ln-eye {
  background: var(--sn-superficie-3) !important;
  border: 1.5px solid var(--sn-borde-fuerte) !important;
  border-left: none !important;
  border-radius: 0 10px 10px 0 !important;
  cursor: pointer;
  color: var(--sn-texto-2);
  padding: 0 14px;
}

/* ── Botón ingresar ── */
.ln-submit {
  width: 100%;
  background: linear-gradient(135deg, var(--sn-accion-hover) 0%, var(--sn-accion) 100%);
  border: none;
  border-radius: 12px;
  color: var(--sn-accion-texto);
  font-size: 15px;
  font-weight: 600;
  padding: 13px;
  cursor: pointer;
  margin-top: 4px;
  margin-bottom: 6px;
  transition: opacity 0.18s, transform 0.12s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  font-family: inherit;
  box-shadow: var(--sn-sombra);
}

.ln-submit:hover  { opacity: 0.92; }
.ln-submit:active { transform: scale(0.98); }
.ln-submit:disabled { opacity: 0.6; cursor: not-allowed; }

.ln-submit--loading { opacity: 0.7; }

/* Spinner dentro del botón */
.ln-spinner {
  width: 20px;
  height: 20px;
  border: 2.5px solid rgba(255,255,255,0.35);
  border-top-color: var(--sn-accion-texto);
  border-radius: 50%;
  display: inline-block;
  animation: lnSpin 0.7s linear infinite;
}

@keyframes lnSpin {
  to { transform: rotate(360deg); }
}

/* ── Botón volver ── */
.ln-back {
  background: none;
  border: none;
  color: var(--sn-marca);
  font-size: 13px;
  cursor: pointer;
  display: block;
  width: 100%;
  text-align: center;
  padding: 6px 0;
  font-family: inherit;
  transition: color 0.15s;
}

.ln-back:hover { color: var(--sn-marca-fuerte); }

/* ── Link contraseña ── */
.ln-link {
  background: none;
  border: none;
  display: block;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: var(--sn-marca);
  cursor: pointer;
  padding: 4px 0;
  font-family: inherit;
  transition: color 0.15s;
}

.ln-link:hover { color: var(--sn-marca-fuerte); text-decoration: underline; }

/* ── Splash: logo pulsante ── */
.ln-splash {
  position: fixed;
  inset: 0;
  background: var(--sn-superficie);
  z-index: 200;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: opacity 0.5s ease, visibility 0.5s;
}

.ln-splash--done {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.ln-splash-logo {
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation: lnLogoBlink 1.4s ease-in-out infinite;
}

.ln-splash-logo img {
  width: 100%;
  height: auto;
}

/* El logo aparece y desaparece suavemente */
@keyframes lnLogoBlink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.15; }
}

.ln-splash-ring { display: none; }

.ln-splash-brand {
  color: var(--sn-marca-fuerte);
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 3px;
  margin-top: 22px;
}

.ln-splash-sub {
  color: var(--sn-texto-3);
  font-size: 10px;
  letter-spacing: 4px;
  margin-top: 3px;
}

.ln-splash-dots {
  display: flex;
  gap: 7px;
  margin-top: 28px;
}

.ln-splash-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--sn-marca);
  animation: lnDot 1s ease-in-out infinite;
}

.ln-splash-dots span:nth-child(2) { animation-delay: 0.15s; }
.ln-splash-dots span:nth-child(3) { animation-delay: 0.3s; }

@keyframes lnDot {
  0%, 100% { opacity: 0.3; transform: scale(0.8); }
  50%       { opacity: 1;   transform: scale(1); }
}

/* ── Entrada escalonada tras el splash ── */
.ln-st {
  opacity: 0;
  transform: translateY(16px);
}

.ln-ready .ln-st {
  animation: lnRise 0.5s cubic-bezier(0.2, 0.7, 0.3, 1) forwards;
}

.ln-ready .ln-st-1 { animation-delay: 0.1s; }
.ln-ready .ln-st-2 { animation-delay: 0.25s; }
.ln-ready .ln-st-3 { animation-delay: 0.4s; }
.ln-ready .ln-st-4 { animation-delay: 0.55s; }

@keyframes lnRise {
  to { opacity: 1; transform: translateY(0); }
}

/* ── Cortina de éxito (login → menú) ── */
.ln-curtain {
  position: fixed;
  inset: 0;
  background: linear-gradient(160deg, var(--sn-accion-hover) 0%, var(--sn-accion) 100%);
  z-index: 300;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  transform: translateY(100%);
}

.ln-curtain--show {
  animation: lnCurtainUp 0.45s cubic-bezier(0.3, 0.7, 0.3, 1) forwards;
}

@keyframes lnCurtainUp {
  to { transform: translateY(0); }
}

.ln-curtain-check {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 3px solid var(--sn-accion-texto);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 38px;
  color: var(--sn-accion-texto);
  opacity: 0;
  transform: scale(0.4);
}

.ln-curtain--show .ln-curtain-check {
  animation: lnPop 0.4s 0.45s cubic-bezier(0.3, 1.4, 0.5, 1) forwards;
}

@keyframes lnPop {
  to { opacity: 1; transform: scale(1); }
}

.ln-curtain-text {
  color: var(--sn-accion-texto);
  font-size: 17px;
  font-weight: 700;
  opacity: 0;
}

.ln-curtain--show .ln-curtain-text {
  animation: lnFadeIn 0.3s 0.7s forwards;
}

@keyframes lnFadeIn {
  to { opacity: 1; }
}

/* ── Pantalla de formulario deslizante ── */
.ln-form-screen {
  position: fixed;
  inset: 0;
  background: var(--sn-superficie);
  z-index: 100;
  transform: translateX(100%);
  transition: transform 0.32s cubic-bezier(0.25, 0.8, 0.35, 1);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.ln-form-screen--open {
  transform: translateX(0);
  /* Canto del panel que entra deslizando. Al 12% de negro no separaba nada
     del fondo oscuro; el token sube la opacidad cuando el tema es oscuro. */
  box-shadow: var(--sn-sombra-panel);
}

.ln-form-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  padding-top: calc(14px + env(safe-area-inset-top, 0));
  border-bottom: 1px solid var(--sn-borde);
}

.ln-back-arrow {
  background: var(--sn-superficie-2);
  border: 1.5px solid var(--sn-borde-fuerte);
  border-radius: 10px;
  width: 40px;
  height: 40px;
  font-size: 20px;
  color: var(--sn-marca);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, transform 0.1s;
  flex-shrink: 0;
  font-family: inherit;
  line-height: 1;
}

.ln-back-arrow:hover  { background: var(--sn-superficie-3); }
.ln-back-arrow:active { transform: scale(0.94); }

.ln-form-header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ln-logo-box--sm {
  width: 30px;
  height: 30px;
  border-radius: 8px;
}

.ln-logo-box--sm span {
  font-size: 14px;
}

.ln-form-header-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--sn-texto);
}

.ln-form-body {
  padding: 24px 24px 20px;
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
}

/* ── Actualización obligatoria ──
   Va por encima del formulario deslizante (100) y por debajo del splash (200),
   así el splash sigue tapándola mientras arranca. */
.ln-update {
  position: fixed;
  inset: 0;
  z-index: 150;
  background: var(--sn-fondo);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  padding-top: calc(20px + env(safe-area-inset-top, 0));
  box-sizing: border-box;
  overflow-y: auto;
}

/* Halo suave de la marca detrás de la tarjeta */
.ln-update::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 22%, var(--sn-marca-suave) 0%, transparent 58%);
  pointer-events: none;
}

.ln-update-card {
  position: relative;
  width: 100%;
  max-width: 340px;
  background: var(--sn-superficie);
  border: 1px solid var(--sn-borde);
  border-radius: 24px;
  padding: 22px 22px 16px;
  box-shadow: var(--sn-sombra);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  animation: lnRise 0.45s cubic-bezier(0.2, 0.7, 0.3, 1) both;
}

.ln-update-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: flex-start;
  margin-bottom: 14px;
}

/* Insignia: círculo de marca con dos anillos que se expanden y desvanecen */
.ln-update-badge {
  position: relative;
  width: 112px;
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px 0 14px;
}

.ln-update-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid var(--sn-marca);
  opacity: 0;
  animation: lnRingPulse 2.6s ease-out infinite;
}

.ln-update-ring--2 { animation-delay: 1.3s; }

@keyframes lnRingPulse {
  0%   { transform: scale(0.68); opacity: 0.5; }
  100% { transform: scale(1.12); opacity: 0; }
}

.ln-update-badge-core {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--sn-marca-fuerte) 0%, var(--sn-marca) 100%);
  color: var(--sn-texto-invertido);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  box-shadow: var(--sn-sombra);
}

.ln-update-badge-core svg {
  width: 36px;
  height: 36px;
  fill: currentColor;
}

.ln-update-title {
  font-size: 21px;
  font-weight: 800;
  color: var(--sn-texto);
  letter-spacing: -0.2px;
  margin: 0 0 6px;
}

.ln-update-text {
  font-size: 13.5px;
  line-height: 1.45;
  color: var(--sn-texto-2);
  margin: 0 0 18px;
}

/* Fichas de versión: instalada → requerida */
.ln-update-versions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.ln-update-chip {
  min-width: 100px;
  padding: 8px 12px;
  border-radius: 12px;
  background: var(--sn-superficie-2);
  border: 1px solid var(--sn-borde);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ln-update-chip small {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--sn-texto-3);
}

.ln-update-chip strong {
  font-size: 15px;
  color: var(--sn-texto);
}

.ln-update-chip--new {
  background: var(--sn-marca-suave);
  border-color: var(--sn-marca);
}

.ln-update-chip--new strong { color: var(--sn-marca-texto); }

.ln-update-arrow {
  color: var(--sn-texto-3);
  display: flex;
  font-size: 14px;
}

.ln-update-btn { gap: 9px; }

.ln-update-btn svg { font-size: 15px; }

.ln-update-sin-enlace {
  font-size: 13px;
  color: var(--sn-alerta-texto);
  margin: 0 0 8px;
}

.ln-update-foot {
  font-size: 11px;
  color: var(--sn-texto-3);
  margin: 10px 0 0;
}

/* ── Versión ── */
.ln-version {
  font-size: 10px;
  color: var(--sn-texto-3);
  text-align: center;
  margin-top: auto;
  padding-top: 8px;
}

/* Ya no hace falta ninguna placa: hay un video del logo por tema
   (logo-animacion.mp4 para claro, logo-animacion-oscuro.mp4 para oscuro)
   y Login.tsx elige el que corresponda. */
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,cAAc,EAAE,mCAAmC;EACnD,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;yEACyE;AACzE;;;qEAGqE;AACrE;EACE;uEACqE;EACrE,sBAAsB,EAAE,sDAAsD;EAC9E;mEACiE;EACjE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B,EAAE,6CAA6C;EAC1E,cAAc;AAChB;;AAEA;wEACwE;AACxE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB,EAAE,oDAAoD;EACtE,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,8EAA8E;EAC9E,8CAA8C;EAC9C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW,UAAU,EAAE,qBAAqB,EAAE;EAC9C,YAAY,UAAU,EAAE,qBAAqB,EAAE;EAC/C,YAAY,YAAY,EAAE,mBAAmB,EAAE;EAC/C,YAAY,UAAU,EAAE,qBAAqB,EAAE;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,WAAW,gCAAgC,EAAE;EAC7C,YAAY,oCAAoC,EAAE;AACpD;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,WAAW,mBAAmB,EAAE,wCAAwC,EAAE;EAC1E,YAAY,sBAAsB,EAAE,6CAA6C,EAAE;AACrF;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,SAAS;EACT,UAAU;EACV,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,OAAO,UAAU,EAAE,qCAAqC,EAAE;EAC1D,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,OAAO,aAAa,EAAE,0BAA0B,EAAE;EAClD,OAAO,UAAU,KAAK,+BAA+B,EAAE;EACvD,OAAO,aAAa,EAAE,0BAA0B,EAAE;AACpD;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,OAAO,aAAa,EAAE,0BAA0B,EAAE;EAClD,OAAO,UAAU,KAAK,+BAA+B,EAAE;EACvD,OAAO,aAAa,EAAE,0BAA0B,EAAE;AACpD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,gDAAgD;AAClD;;AAEA,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,qBAAqB,EAAE;;AAEtD;EACE,gBAAgB,wBAAwB,EAAE,YAAY,EAAE;EACxD,iBAAiB,2BAA2B,EAAE,UAAU,EAAE;AAC5D;;AAEA,4CAA4C;AAC5C;EACE,4CAA4C;AAC9C;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA,iCAAiC;AACjC;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,+BAA+B;AAC/B;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW,8DAA8D,EAAE;EAC3E,YAAY,iEAAiE,EAAE;AACjF;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,YAAY,wBAAwB,EAAE;EACtC,YAAY,wBAAwB,EAAE;AACxC;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,YAAY,uBAAuB,EAAE;EACrC,YAAY,wBAAwB,EAAE;AACxC;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,YAAY,uBAAuB,EAAE;AACvC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,YAAY,EAAE;AAC5B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,uEAAuE;AACvE;EACE,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iEAAiE;EACjE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,qDAAqD;EACrD,8BAA8B;EAC9B,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA2D;AAC7D;;AAEA;EACE,wCAAwC;EACxC,sDAAsD;EACtD,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,qDAAqD;EACrD,4BAA4B;EAC5B,uCAAuC;EACvC,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,qFAAqF;EACrF,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,oBAAoB,aAAa,EAAE;AACnC,oBAAoB,sBAAsB,EAAE;AAC5C,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD,sBAAsB,YAAY,EAAE;;AAEpC,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,iBAAiB,6BAA6B,EAAE;;AAEhD,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,iBAAiB,6BAA6B,EAAE,0BAA0B,EAAE;;AAE5E,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,aAAa,EAAE;AAC7B;;AAEA,kBAAkB,aAAa,EAAE;;AAEjC;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,oCAAoC,sBAAsB,EAAE;AAC5D,oCAAoC,qBAAqB,EAAE;;AAE3D;EACE,WAAW,YAAY,EAAE,qBAAqB,EAAE;EAChD,YAAY,UAAU,IAAI,mBAAmB,EAAE;AACjD;;AAEA,4CAA4C;AAC5C;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,8DAA8D;AAChE;;AAEA,qBAAqB,qBAAqB,EAAE;AAC5C,qBAAqB,sBAAsB,EAAE;AAC7C,qBAAqB,qBAAqB,EAAE;AAC5C,qBAAqB,sBAAsB,EAAE;;AAE7C;EACE,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ;EACR,qFAAqF;EACrF,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,KAAK,UAAU,EAAE;AACnB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;EAC3B,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB;4EAC0E;EAC1E,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA,wBAAwB,kCAAkC,EAAE;AAC5D,wBAAwB,sBAAsB,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;oDAEoD;AACpD;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qDAAqD;EACrD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,yFAAyF;EACzF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,UAAU;EACV,6CAA6C;AAC/C;;AAEA,qBAAqB,qBAAqB,EAAE;;AAE5C;EACE,OAAO,sBAAsB,EAAE,YAAY,EAAE;EAC7C,OAAO,sBAAsB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oFAAoF;EACpF,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA,8BAA8B,4BAA4B,EAAE;;AAE5D;EACE,wBAAwB;EACxB,aAAa;EACb,eAAe;AACjB;;AAEA,iBAAiB,QAAQ,EAAE;;AAE3B,qBAAqB,eAAe,EAAE;;AAEtC;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;0CAE0C","sourcesContent":["/* ── Reset base ── */\nhtml, body, #root {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  background: var(--sn-superficie);\n  overflow-x: hidden;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* ── Wrapper principal ── */\n.ln-wrapper {\n  height: 100vh;\n  height: 100dvh; /* altura real visible en móviles */\n  background: var(--sn-superficie);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px 10px;\n  box-sizing: border-box;\n  overflow: hidden; /* todo cabe en una pantalla, sin scroll */\n}\n\n/* ── Logo ── */\n.ln-logo-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  max-width: 360px;\n  margin-bottom: 8px;\n  padding-top: env(safe-area-inset-top, 0);\n}\n\n/* Logo horizontal de la marca, en el espacio de la ilustración.\n   El JPG trae fondo blanco, que coincide con el fondo claro del login. */\n/* El video del logo es cuadrado, pero el logo dentro es horizontal: un 34%\n   del cuadro son franjas blancas vacías arriba y abajo. Se recorta ese vacío\n   dándole al contenedor la proporción del contenido real y usando \"cover\".\n   El recorte es solo vertical: a lo ancho se ve el video completo. */\n.ln-stage.ln-stage--video {\n  /* El video es cuadrado pero el logo ocupa 1402x1182: sobra un 18% vertical.\n     Se recorta ese vacío (solo vertical; a lo ancho se ve completo). */\n  aspect-ratio: 1.16 / 1; /* más específico que el .ln-stage cuadrado de abajo */\n  /* Dentro de un flex en columna, el alto natural del video (cuadrado) haría\n     crecer la caja e ignoraría la proporción. Esto se lo impide. */\n  min-height: 0;\n  flex: 0 0 auto;\n}\n\n.ln-logo-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 66%; /* compensa que el logo está bajo el centro */\n  display: block;\n}\n\n/* Ícono de la marca en la cabecera del login.\n   Mismo logo y estilo que la barra superior de la app (.an-logo-img). */\n.ln-logo-img {\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n/* Versión pequeña, para la cabecera de \"Iniciar sesión\". */\n.ln-logo-img--sm {\n  width: 30px;\n  height: 30px;\n}\n\n.ln-logo-box {\n  width: 44px;\n  height: 44px;\n  background: linear-gradient(135deg, var(--sn-marca-fuerte) 0%, var(--sn-marca) 100%);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: var(--sn-sombra);\n}\n\n.ln-logo-box span {\n  color: var(--sn-texto-invertido);\n  font-size: 20px;\n  font-weight: 900;\n  letter-spacing: -1px;\n}\n\n.ln-brand {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--sn-marca-fuerte);\n  line-height: 1.1;\n  letter-spacing: .5px;\n}\n\n.ln-subbrand {\n  font-size: 10px;\n  color: var(--sn-texto-3);\n  font-weight: 500;\n  letter-spacing: 1px;\n}\n\n/* ── Ilustración ── */\n.ln-illus-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 360px;\n  margin-bottom: 4px;\n}\n\n.ln-svg {\n  width: auto;\n  max-width: 230px;\n  height: auto;\n  max-height: 30vh; /* la ilustración se adapta a la altura disponible */\n  min-height: 0;\n}\n\n/* ── Escenario con la ilustración ── */\n.ln-stage {\n  position: relative;\n  width: 230px;\n  max-width: 100%;\n  aspect-ratio: 1 / 1;\n  margin: 0 auto;\n  border-radius: 20px;\n}\n\n.ln-stage--solo {\n  background: var(--sn-superficie-2);\n}\n\n.ln-lottie {\n  width: 100%;\n  height: 100%;\n}\n\n.ln-glow {\n  position: absolute;\n  left: 51%;\n  top: 20%;\n  width: 16%;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  background: radial-gradient(circle, var(--sn-marca-suave) 0%, transparent 70%);\n  animation: lnGlowPulse 3s ease-in-out infinite;\n  animation-delay: 1.1s;\n  pointer-events: none;\n}\n\n@keyframes lnGlowPulse {\n  0%, 100% { opacity: 0; transform: scale(0.6); }\n  20%       { opacity: 1; transform: scale(1.1); }\n  55%       { opacity: 0.7; transform: scale(1); }\n  75%       { opacity: 0; transform: scale(0.8); }\n}\n\n.ln-fx {\n  position: absolute;\n}\n\n.ln-fx svg {\n  width: 100%;\n  display: block;\n}\n\n.ln-fx-chat {\n  left: 4%;\n  top: 36%;\n  width: 15%;\n  transform-origin: 30% 70%;\n  animation: lnBubblePulse 2.4s ease-in-out infinite;\n}\n\n@keyframes lnBubblePulse {\n  0%, 100% { transform: scale(1) rotate(0deg); }\n  50%       { transform: scale(1.12) rotate(-4deg); }\n}\n\n.ln-fx-play {\n  left: 46%;\n  top: 56%;\n  width: 12%;\n  animation: lnPlayPulse 1.6s ease-in-out infinite;\n}\n\n@keyframes lnPlayPulse {\n  0%, 100% { transform: scale(1); filter: drop-shadow(0 0 0px transparent); }\n  50%       { transform: scale(1.15); filter: drop-shadow(0 0 10px var(--sn-marca)); }\n}\n\n.ln-fx-reply {\n  left: 46%;\n  top: 12%;\n  width: 9%;\n  opacity: 0;\n  animation: lnReplyPop 3s ease-in-out infinite;\n  animation-delay: 1.1s;\n}\n\n@keyframes lnReplyPop {\n  0%   { opacity: 0; transform: scale(0.4) translateY(10px); }\n  12%  { opacity: 1; transform: scale(1.15) translateY(-4px); }\n  22%  { opacity: 1; transform: scale(1) translateY(0); }\n  55%  { opacity: 1; transform: scale(1) translateY(0); }\n  75%  { opacity: 0; transform: scale(0.7) translateY(6px); }\n  100% { opacity: 0; transform: scale(0.4) translateY(10px); }\n}\n\n.ln-fx-arrow1 {\n  left: 28%;\n  top: 25%;\n  width: 18%;\n  animation: lnArrowFlow1 2.4s ease-in-out infinite;\n}\n\n@keyframes lnArrowFlow1 {\n  0%   { opacity: 0.35; transform: translate(0, 0); }\n  45%  { opacity: 1;    transform: translate(4px, -4px); }\n  100% { opacity: 0.35; transform: translate(0, 0); }\n}\n\n.ln-fx-arrow2 {\n  left: 62%;\n  top: 50%;\n  width: 15%;\n  animation: lnArrowFlow2 2.4s ease-in-out infinite;\n  animation-delay: 1.2s;\n}\n\n@keyframes lnArrowFlow2 {\n  0%   { opacity: 0.35; transform: translate(0, 0); }\n  45%  { opacity: 1;    transform: translate(-4px, 4px); }\n  100% { opacity: 0.35; transform: translate(0, 0); }\n}\n\n.ln-typing {\n  position: absolute;\n  left: 33%;\n  top: 87%;\n  display: flex;\n  gap: 5px;\n}\n\n.ln-typing span {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--sn-marca);\n  opacity: 0.85;\n  animation: lnDotBounce 1.1s ease-in-out infinite;\n}\n\n.ln-typing span:nth-child(2) { animation-delay: 0.15s; }\n.ln-typing span:nth-child(3) { animation-delay: 0.3s; }\n\n@keyframes lnDotBounce {\n  0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }\n  30%            { transform: translateY(-5px); opacity: 1; }\n}\n\n/* Animación: flote suave de todo el grupo */\n.ln-svg-float {\n  animation: lnFloat 3.6s ease-in-out infinite;\n}\n\n/* Animación: brazo saludando */\n.ln-svg-wave {\n  transform-origin: 1020px 410px;\n  animation: lnWave 2.2s ease-in-out infinite;\n}\n\n/* Animación: cabeza asintiendo */\n.ln-svg-nod {\n  transform-origin: 910px 370px;\n  animation: lnNod 4.5s ease-in-out infinite;\n}\n\n/* Animación: planta meciéndose */\n.ln-svg-sway {\n  transform-origin: center bottom;\n  animation: lnSway 3.2s ease-in-out infinite;\n}\n\n/* Animación: pulso del punto */\n.ln-svg-pulse {\n  animation: lnPulse 1.8s ease-in-out infinite;\n}\n\n@keyframes lnFloat {\n  0%, 100% { transform: translateY(0) translateX(-601px) translateY(-140px); }\n  50%       { transform: translateY(-8px) translateX(-601px) translateY(-140px); }\n}\n\n@keyframes lnWave {\n  0%, 100% { transform: rotate(0deg); }\n  30%       { transform: rotate(10deg); }\n  70%       { transform: rotate(-5deg); }\n}\n\n@keyframes lnNod {\n  0%, 100% { transform: rotate(0deg); }\n  35%       { transform: rotate(4deg); }\n  70%       { transform: rotate(-3deg); }\n}\n\n@keyframes lnSway {\n  0%, 100% { transform: rotate(0deg); }\n  50%       { transform: rotate(4deg); }\n}\n\n@keyframes lnPulse {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.4; }\n}\n\n/* Frase */\n.ln-tagline {\n  font-size: 12px;\n  color: var(--sn-marca);\n  font-weight: 600;\n  font-style: italic;\n  text-align: center;\n  margin: 0;\n  letter-spacing: 0.2px;\n}\n\n/* ── Tarjeta de acceso ── */\n.ln-card {\n  width: 100%;\n  max-width: 360px;\n  padding: 10px 0 0;\n}\n\n/* ── Alerta de error ── */\n.ln-alert {\n  background: var(--sn-peligro-suave);\n  border: 1px solid var(--sn-peligro);\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: var(--sn-peligro-texto);\n  margin-bottom: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Aviso informativo (no es un error): sesión cerrada por inactividad */\n.ln-alert--info {\n  background: var(--sn-info-suave);\n  border-color: var(--sn-borde-fuerte);\n  color: var(--sn-info-texto);\n}\n\n.ln-alert-icon {\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n/* ── Títulos ── */\n.ln-heading {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--sn-texto);\n  margin: 0 0 4px;\n}\n\n.ln-subheading {\n  font-size: 13px;\n  color: var(--sn-texto-2);\n  margin: 0 0 18px;\n}\n\n/* ── Grid de botones de acceso (modo íconos) ── */\n.ln-btn-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.ln-access-btn {\n  background: var(--sn-superficie-2);\n  border: 1.5px solid var(--sn-borde-fuerte);\n  border-radius: 16px;\n  padding: 18px 10px 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: border-color 0.18s, background 0.18s, transform 0.12s;\n  font-family: inherit;\n}\n\n.ln-access-btn:hover {\n  background: var(--sn-superficie-3);\n  border-color: var(--sn-marca);\n}\n\n.ln-access-btn:active {\n  transform: scale(0.97);\n}\n\n.ln-access-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ln-access-icon {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, var(--sn-marca-fuerte) 0%, var(--sn-marca) 100%);\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--sn-sombra);\n}\n\n.ln-access-icon svg {\n  width: 26px;\n  height: 26px;\n  color: var(--sn-texto-invertido);\n  fill: var(--sn-texto-invertido);\n}\n\n.ln-access-icon {\n  font-size: 26px;\n  color: var(--sn-texto-invertido);\n}\n\n.ln-access-btn span {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--sn-texto-2);\n  text-align: center;\n  line-height: 1.4;\n}\n\n/* ── Formulario ── */\n.ln-field {\n  margin-bottom: 14px;\n}\n\n.ln-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--sn-texto-2);\n  margin-bottom: 6px;\n  display: block;\n}\n\n.ln-input {\n  background: var(--sn-superficie-3) !important;\n  border: 1.5px solid var(--sn-borde-fuerte) !important;\n  border-radius: 10px !important;\n  font-size: 14px !important;\n  color: var(--sn-texto) !important;\n  padding: 10px 14px !important;\n  transition: border-color 0.18s, box-shadow 0.18s !important;\n}\n\n.ln-input:focus {\n  border-color: var(--sn-marca) !important;\n  box-shadow: 0 0 0 3px var(--sn-marca-suave) !important;\n  background: var(--sn-superficie) !important;\n}\n\n.ln-input::placeholder {\n  color: var(--sn-texto-3) !important;\n}\n\n.ln-eye {\n  background: var(--sn-superficie-3) !important;\n  border: 1.5px solid var(--sn-borde-fuerte) !important;\n  border-left: none !important;\n  border-radius: 0 10px 10px 0 !important;\n  cursor: pointer;\n  color: var(--sn-texto-2);\n  padding: 0 14px;\n}\n\n/* ── Botón ingresar ── */\n.ln-submit {\n  width: 100%;\n  background: linear-gradient(135deg, var(--sn-accion-hover) 0%, var(--sn-accion) 100%);\n  border: none;\n  border-radius: 12px;\n  color: var(--sn-accion-texto);\n  font-size: 15px;\n  font-weight: 600;\n  padding: 13px;\n  cursor: pointer;\n  margin-top: 4px;\n  margin-bottom: 6px;\n  transition: opacity 0.18s, transform 0.12s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  font-family: inherit;\n  box-shadow: var(--sn-sombra);\n}\n\n.ln-submit:hover  { opacity: 0.92; }\n.ln-submit:active { transform: scale(0.98); }\n.ln-submit:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.ln-submit--loading { opacity: 0.7; }\n\n/* Spinner dentro del botón */\n.ln-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2.5px solid rgba(255,255,255,0.35);\n  border-top-color: var(--sn-accion-texto);\n  border-radius: 50%;\n  display: inline-block;\n  animation: lnSpin 0.7s linear infinite;\n}\n\n@keyframes lnSpin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Botón volver ── */\n.ln-back {\n  background: none;\n  border: none;\n  color: var(--sn-marca);\n  font-size: 13px;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n  text-align: center;\n  padding: 6px 0;\n  font-family: inherit;\n  transition: color 0.15s;\n}\n\n.ln-back:hover { color: var(--sn-marca-fuerte); }\n\n/* ── Link contraseña ── */\n.ln-link {\n  background: none;\n  border: none;\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-size: 12px;\n  color: var(--sn-marca);\n  cursor: pointer;\n  padding: 4px 0;\n  font-family: inherit;\n  transition: color 0.15s;\n}\n\n.ln-link:hover { color: var(--sn-marca-fuerte); text-decoration: underline; }\n\n/* ── Splash: logo pulsante ── */\n.ln-splash {\n  position: fixed;\n  inset: 0;\n  background: var(--sn-superficie);\n  z-index: 200;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.5s ease, visibility 0.5s;\n}\n\n.ln-splash--done {\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.ln-splash-logo {\n  width: 170px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  animation: lnLogoBlink 1.4s ease-in-out infinite;\n}\n\n.ln-splash-logo img {\n  width: 100%;\n  height: auto;\n}\n\n/* El logo aparece y desaparece suavemente */\n@keyframes lnLogoBlink {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.15; }\n}\n\n.ln-splash-ring { display: none; }\n\n.ln-splash-brand {\n  color: var(--sn-marca-fuerte);\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: 3px;\n  margin-top: 22px;\n}\n\n.ln-splash-sub {\n  color: var(--sn-texto-3);\n  font-size: 10px;\n  letter-spacing: 4px;\n  margin-top: 3px;\n}\n\n.ln-splash-dots {\n  display: flex;\n  gap: 7px;\n  margin-top: 28px;\n}\n\n.ln-splash-dots span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--sn-marca);\n  animation: lnDot 1s ease-in-out infinite;\n}\n\n.ln-splash-dots span:nth-child(2) { animation-delay: 0.15s; }\n.ln-splash-dots span:nth-child(3) { animation-delay: 0.3s; }\n\n@keyframes lnDot {\n  0%, 100% { opacity: 0.3; transform: scale(0.8); }\n  50%       { opacity: 1;   transform: scale(1); }\n}\n\n/* ── Entrada escalonada tras el splash ── */\n.ln-st {\n  opacity: 0;\n  transform: translateY(16px);\n}\n\n.ln-ready .ln-st {\n  animation: lnRise 0.5s cubic-bezier(0.2, 0.7, 0.3, 1) forwards;\n}\n\n.ln-ready .ln-st-1 { animation-delay: 0.1s; }\n.ln-ready .ln-st-2 { animation-delay: 0.25s; }\n.ln-ready .ln-st-3 { animation-delay: 0.4s; }\n.ln-ready .ln-st-4 { animation-delay: 0.55s; }\n\n@keyframes lnRise {\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* ── Cortina de éxito (login → menú) ── */\n.ln-curtain {\n  position: fixed;\n  inset: 0;\n  background: linear-gradient(160deg, var(--sn-accion-hover) 0%, var(--sn-accion) 100%);\n  z-index: 300;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  transform: translateY(100%);\n}\n\n.ln-curtain--show {\n  animation: lnCurtainUp 0.45s cubic-bezier(0.3, 0.7, 0.3, 1) forwards;\n}\n\n@keyframes lnCurtainUp {\n  to { transform: translateY(0); }\n}\n\n.ln-curtain-check {\n  width: 76px;\n  height: 76px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n  border: 3px solid var(--sn-accion-texto);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 38px;\n  color: var(--sn-accion-texto);\n  opacity: 0;\n  transform: scale(0.4);\n}\n\n.ln-curtain--show .ln-curtain-check {\n  animation: lnPop 0.4s 0.45s cubic-bezier(0.3, 1.4, 0.5, 1) forwards;\n}\n\n@keyframes lnPop {\n  to { opacity: 1; transform: scale(1); }\n}\n\n.ln-curtain-text {\n  color: var(--sn-accion-texto);\n  font-size: 17px;\n  font-weight: 700;\n  opacity: 0;\n}\n\n.ln-curtain--show .ln-curtain-text {\n  animation: lnFadeIn 0.3s 0.7s forwards;\n}\n\n@keyframes lnFadeIn {\n  to { opacity: 1; }\n}\n\n/* ── Pantalla de formulario deslizante ── */\n.ln-form-screen {\n  position: fixed;\n  inset: 0;\n  background: var(--sn-superficie);\n  z-index: 100;\n  transform: translateX(100%);\n  transition: transform 0.32s cubic-bezier(0.25, 0.8, 0.35, 1);\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.ln-form-screen--open {\n  transform: translateX(0);\n  /* Canto del panel que entra deslizando. Al 12% de negro no separaba nada\n     del fondo oscuro; el token sube la opacidad cuando el tema es oscuro. */\n  box-shadow: var(--sn-sombra-panel);\n}\n\n.ln-form-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  padding-top: calc(14px + env(safe-area-inset-top, 0));\n  border-bottom: 1px solid var(--sn-borde);\n}\n\n.ln-back-arrow {\n  background: var(--sn-superficie-2);\n  border: 1.5px solid var(--sn-borde-fuerte);\n  border-radius: 10px;\n  width: 40px;\n  height: 40px;\n  font-size: 20px;\n  color: var(--sn-marca);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, transform 0.1s;\n  flex-shrink: 0;\n  font-family: inherit;\n  line-height: 1;\n}\n\n.ln-back-arrow:hover  { background: var(--sn-superficie-3); }\n.ln-back-arrow:active { transform: scale(0.94); }\n\n.ln-form-header-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ln-logo-box--sm {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n}\n\n.ln-logo-box--sm span {\n  font-size: 14px;\n}\n\n.ln-form-header-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--sn-texto);\n}\n\n.ln-form-body {\n  padding: 24px 24px 20px;\n  width: 100%;\n  max-width: 360px;\n  margin: 0 auto;\n}\n\n/* ── Actualización obligatoria ──\n   Va por encima del formulario deslizante (100) y por debajo del splash (200),\n   así el splash sigue tapándola mientras arranca. */\n.ln-update {\n  position: fixed;\n  inset: 0;\n  z-index: 150;\n  background: var(--sn-fondo);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  padding-top: calc(20px + env(safe-area-inset-top, 0));\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n/* Halo suave de la marca detrás de la tarjeta */\n.ln-update::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 50% 22%, var(--sn-marca-suave) 0%, transparent 58%);\n  pointer-events: none;\n}\n\n.ln-update-card {\n  position: relative;\n  width: 100%;\n  max-width: 340px;\n  background: var(--sn-superficie);\n  border: 1px solid var(--sn-borde);\n  border-radius: 24px;\n  padding: 22px 22px 16px;\n  box-shadow: var(--sn-sombra);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  animation: lnRise 0.45s cubic-bezier(0.2, 0.7, 0.3, 1) both;\n}\n\n.ln-update-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  align-self: flex-start;\n  margin-bottom: 14px;\n}\n\n/* Insignia: círculo de marca con dos anillos que se expanden y desvanecen */\n.ln-update-badge {\n  position: relative;\n  width: 112px;\n  height: 112px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 4px 0 14px;\n}\n\n.ln-update-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 2px solid var(--sn-marca);\n  opacity: 0;\n  animation: lnRingPulse 2.6s ease-out infinite;\n}\n\n.ln-update-ring--2 { animation-delay: 1.3s; }\n\n@keyframes lnRingPulse {\n  0%   { transform: scale(0.68); opacity: 0.5; }\n  100% { transform: scale(1.12); opacity: 0; }\n}\n\n.ln-update-badge-core {\n  width: 78px;\n  height: 78px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--sn-marca-fuerte) 0%, var(--sn-marca) 100%);\n  color: var(--sn-texto-invertido);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 34px;\n  box-shadow: var(--sn-sombra);\n}\n\n.ln-update-badge-core svg {\n  width: 36px;\n  height: 36px;\n  fill: currentColor;\n}\n\n.ln-update-title {\n  font-size: 21px;\n  font-weight: 800;\n  color: var(--sn-texto);\n  letter-spacing: -0.2px;\n  margin: 0 0 6px;\n}\n\n.ln-update-text {\n  font-size: 13.5px;\n  line-height: 1.45;\n  color: var(--sn-texto-2);\n  margin: 0 0 18px;\n}\n\n/* Fichas de versión: instalada → requerida */\n.ln-update-versions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.ln-update-chip {\n  min-width: 100px;\n  padding: 8px 12px;\n  border-radius: 12px;\n  background: var(--sn-superficie-2);\n  border: 1px solid var(--sn-borde);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ln-update-chip small {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: var(--sn-texto-3);\n}\n\n.ln-update-chip strong {\n  font-size: 15px;\n  color: var(--sn-texto);\n}\n\n.ln-update-chip--new {\n  background: var(--sn-marca-suave);\n  border-color: var(--sn-marca);\n}\n\n.ln-update-chip--new strong { color: var(--sn-marca-texto); }\n\n.ln-update-arrow {\n  color: var(--sn-texto-3);\n  display: flex;\n  font-size: 14px;\n}\n\n.ln-update-btn { gap: 9px; }\n\n.ln-update-btn svg { font-size: 15px; }\n\n.ln-update-sin-enlace {\n  font-size: 13px;\n  color: var(--sn-alerta-texto);\n  margin: 0 0 8px;\n}\n\n.ln-update-foot {\n  font-size: 11px;\n  color: var(--sn-texto-3);\n  margin: 10px 0 0;\n}\n\n/* ── Versión ── */\n.ln-version {\n  font-size: 10px;\n  color: var(--sn-texto-3);\n  text-align: center;\n  margin-top: auto;\n  padding-top: 8px;\n}\n\n/* Ya no hace falta ninguna placa: hay un video del logo por tema\n   (logo-animacion.mp4 para claro, logo-animacion-oscuro.mp4 para oscuro)\n   y Login.tsx elige el que corresponda. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
